import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import LookListMainFeature from "./lookListMainFeature";

const LookListBundleFeatures = (props) => {

  const {cartItem, cartItems} = props;
  const {cartFeature} = cartItem;

  const cartItemsList = cartItems.filter(cItem => {
    return cItem.relatedProductParent && (cItem.relatedProductParent.dbFeature.id === cartFeature.dbFeature.id);
  });

  // console.log("cartItem", cartItem);
  // console.log("cartItemsList", cartItemsList);

  return (
    <div className="ll-feature__bundle">
      <ul className="ll-main__list">
        {cartItemsList.map(cartItem => {
          return <LookListMainFeature cartItem={cartItem} key={cartItem.id} isBundleChild={true}/>
        })}
      </ul>
    </div>
  )
};

LookListBundleFeatures.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired
}

const mapStateToProps = (store, ownProps) => {
  const {lookExpanded, lookViewType} = store.lookState;
  const {cartItems} = store.cartState;
  return {
    lookExpanded,
    lookViewType,
    quantity: ownProps.cartItem.quantity,
    cartItems,
  };
};

const mapDispatchToProps = {

};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookListBundleFeatures)
)
